import {
    Button,
    Checkbox,
} from '@chakra-ui/react'
import { BiFilter } from 'react-icons/bi'
import styles from "./style.module.css"
import ReactDatePicker from 'react-datepicker'
import { useState } from 'react'
import { Modal } from 'antd'

function Filter({ setType, startDate, setStartDate, endDate, setEndDate, setFilterApplied, filter, setFilter }) {
    const [open, setOpen] = useState(false);
    console.log(startDate);
    // const formattedStartDate = startDate.toDateString(); 
    // const formattedEndDate = endDate.toDateString();

    return (
        <>
            <Button onClick={() => setOpen(true)}>Filter  <BiFilter fontSize={20} marginLeft={10} /></Button>

            <Modal

                centered
                open={open}
                footer={null}
                onCancel={() => setOpen(false)}

                width={800}
            >
                <p className={styles.applyFilter}>Apply Filter</p>

                <div className={styles.filterDiv2}>
                    <div className={styles.innerFilter1}>
                        <p>Status</p>
                        <div >
                            <span> <Checkbox checked={filter.isApproved} onChange={() => setFilter({ ...filter, isApproved: !filter.isApproved })} /> <p>Approved</p></span>
                            <span> <Checkbox checked={filter.isRequested} onChange={() => setFilter({ ...filter, isRequested: !filter.isRequested })} /> <p>In Verification</p></span>
                            <span> <Checkbox checked={filter.isRejected} onChange={() => setFilter({ ...filter, isRejected: !filter.isRejected })} /> <p>Reject</p></span>
                        </div>
                    </div>
                    <div className={styles.innerFilter}>
                        <p>Date Range</p>
                        <div>
                            <p>Between 26May to 25June  2023</p>

                            <div>
                                <p>Select Created on*</p>
                                <div>
                                    <ReactDatePicker selected={startDate} onChange={(e) => setStartDate(e)} placeholderText='Start date' />
                                    <ReactDatePicker minDate={startDate} selected={endDate} onChange={(e) => setEndDate(e)} placeholderText='End date' />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <button className={styles.blackBtn321} onClick={() => {
                    setFilterApplied((prev) => !prev)
                    setOpen(false)
                    setType("Overview")

                }}>Apply</button>

            </Modal>
        </>
    )
}
export default Filter